/**
 * nf-cart-drawer-upsell.js
 * Handles: ATC, variant price update, arrow navigation, drag-to-scroll.
 */

(function () {
  'use strict';

  var DEFINED = false;

  function define() {
    if (DEFINED || customElements.get('nf-cart-drawer-upsell')) return;
    DEFINED = true;

    class NfCartDrawerUpsell extends HTMLElement {
      connectedCallback() {
        var self = this;
        /* defer one tick so morphed DOM is fully settled before we bind */
        setTimeout(function() {
          if (!self.isConnected) return;
          self._bindCards();
          self._initScroll();
        }, 0);
      }

      /* ── Variant selects + ATC buttons ── */
      _bindCards() {
        var self = this;
        this.querySelectorAll('.nf-cdu__card').forEach(function(card) {
          var btn = card.querySelector('.nf-cdu__atc');
          var sel = card.querySelector('.nf-cdu__variant');

          if (sel && !sel._nfBound) {
            sel._nfBound = true;
            sel.addEventListener('change', function() {
              var opt = sel.selectedOptions[0];

              /* update stored variant id */
              card.dataset.variantId = opt.value;
              if (btn) btn.dataset.variantId = opt.value;
              if (btn) btn.disabled = opt.disabled;

              /* update displayed price using Liquid-formatted strings */
              var ps = card.querySelector('.nf-cdu__price-sale');
              var pw = card.querySelector('.nf-cdu__price-was');

              if (ps) ps.textContent = opt.dataset.priceFmt || opt.dataset.price;

              var cmpFmt = opt.dataset.cmpFmt;
              if (cmpFmt) {
                if (!pw) {
                  pw = document.createElement('s');
                  pw.className = 'nf-cdu__price-was';
                  if (ps) ps.after(pw);
                }
                pw.textContent = cmpFmt;
                pw.removeAttribute('hidden');
              } else if (pw) {
                pw.setAttribute('hidden', '');
              }
            });
          }

          if (btn && !btn._nfBound) {
            btn._nfBound = true;
            btn.addEventListener('click', function() {
              self._addToCart(card);
            });
          }
        });
      }

      /* ── Arrow navigation + drag-to-scroll (carousel only) ── */
      _initScroll() {
        if (this.dataset.layout === 'grid' || this.dataset.layout === 'grid2x3' || this.dataset.layout === 'grid3') return;
        var scroll = this.querySelector('[data-nf-cdu-scroll]');
        var prev   = this.querySelector('[data-nf-cdu-prev]');
        var next   = this.querySelector('[data-nf-cdu-next]');
        if (!scroll) return;

        /* -- arrow visibility -- */
        var updateArrows = function() {
          var atStart = scroll.scrollLeft <= 2;
          var atEnd   = scroll.scrollLeft >= scroll.scrollWidth - scroll.clientWidth - 2;
          if (prev) { if (atStart) prev.setAttribute('hidden', ''); else prev.removeAttribute('hidden'); }
          if (next) { if (atEnd)   next.setAttribute('hidden', ''); else next.removeAttribute('hidden'); }
        };
        scroll.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();

        /* -- arrow clicks -- */
        var cardWidth = 118 + 8;
        if (prev) prev.addEventListener('click', function() { scroll.scrollBy({ left: -cardWidth * 2, behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function() { scroll.scrollBy({ left:  cardWidth * 2, behavior: 'smooth' }); });

        /* -- drag-to-scroll -- */
        var dragging   = false;
        var moved      = false;
        var startX     = 0;
        var startLeft  = 0;

        scroll.addEventListener('mousedown', function(e) {
          dragging  = true;
          moved     = false;
          startX    = e.pageX;
          startLeft = scroll.scrollLeft;
          scroll.classList.add('nf-cdu--dragging');
          e.preventDefault();
        });

        document.addEventListener('mousemove', function(e) {
          if (!dragging) return;
          var dx = e.pageX - startX;
          if (Math.abs(dx) > 4) moved = true;
          scroll.scrollLeft = startLeft - dx;
        });

        document.addEventListener('mouseup', function(e) {
          if (!dragging) return;
          dragging = false;
          scroll.classList.remove('nf-cdu--dragging');
          if (moved) {
            /* block the click that fires after mouseup so ATC doesn't trigger */
            scroll.addEventListener('click', function stop(ev) {
              ev.stopPropagation();
              ev.preventDefault();
              scroll.removeEventListener('click', stop, true);
            }, true);
          }
        });
      }

      /* ── Add to cart ── */
      async _addToCart(card) {
        var btn = card.querySelector('.nf-cdu__atc');
        var variantId = parseInt(btn.dataset.variantId || card.dataset.variantId, 10);
        if (!variantId || btn.disabled) return;

        btn.disabled = true;
        btn.classList.add('nf-cdu__atc--busy');

        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!res.ok) throw new Error('add failed');

          var cartRes = await fetch('/cart.js');
          var updCart = await cartRes.json();

          try {
            localStorage.setItem('nf_last_added_product', JSON.stringify({
              productId: parseInt(card.dataset.productId, 10),
              variantId: variantId,
              ts: Date.now()
            }));
          } catch (_) {}

          card.classList.add('nf-cdu__card--added');
          btn.classList.remove('nf-cdu__atc--busy');
          btn.classList.add('nf-cdu__atc--done');

          var ev = new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: updCart, sourceId: 'nf-cdu', data: { source: 'nf-cdu', sections: {} } }
          });
          ev._nf_cdu = true;
          document.dispatchEvent(ev);

        } catch (_) {
          btn.disabled = false;
          btn.classList.remove('nf-cdu__atc--busy');
        }
      }
    }

    customElements.define('nf-cart-drawer-upsell', NfCartDrawerUpsell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', define);
  } else {
    define();
  }
})();
